import React from "react";
import MainLayout from "./MainLayout";
import ProfileChecklistDetails from "../common/Profile/SkillRatingsProfile";

const ProfileChecklistDetailsPage = (props) => <MainLayout component={ProfileChecklistDetails} />;

export default ProfileChecklistDetailsPage;
